import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  input,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[preventFocusScroll]',
})
export class PreventFocusScrollDirective implements AfterViewInit, OnDestroy {
  targetSelector = input.required<string>();
  private targets: HTMLElement[] = [];
  private eventListeners: (() => void)[] = [];

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const targetSelector = this.targetSelector();
    this.targets = Array.from(
      this.el.nativeElement.querySelectorAll(targetSelector)
    );

    if (this.targets.length === 0) {
      console.warn(
        `PreventFocusScrollDirective: No elements found with selector "${targetSelector}".`
      );
      return;
    }

    // Add mousedown listener to each target
    this.targets.forEach((target) => {
      const onMouseDown = () => this.handleMouseDown(target);
      target.addEventListener('mousedown', onMouseDown);

      // Store cleanup function
      this.eventListeners.push(() => {
        target.removeEventListener('mousedown', onMouseDown);
      });
    });
  }

  ngOnDestroy() {
    // Clean up all event listeners
    this.eventListeners.forEach((cleanup) => cleanup());
  }

  // Keep the original @HostListener for backward compatibility if needed
  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Check if the clicked element is one of our targets or inside one
    const matchingTarget = this.targets.find(
      (el) => el === target || el.contains(target)
    );

    if (matchingTarget) {
      this.handleMouseDown(matchingTarget);
    }
  }

  private handleMouseDown(target: HTMLElement) {
    const originalScrollIntoView = target.scrollIntoView;

    // Block scrollIntoView during click
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    target.scrollIntoView = () => {};

    // Restore after click completes
    setTimeout(() => {
      target.scrollIntoView = originalScrollIntoView;
    }, 50);
  }
}
